<template>
  <el-dialog style="max-height: 80%;top: 10%;" width="620px" :title="'房间详情'" :visible.sync="visible" :append-to-body="true" @close="$emit('update:show', false)">
    <div class="useDetails">
      <p class="useDetails_title">
        <span>订单号：{{ detailData.orderCode }}</span>
        <span>共使用人数：{{ useDetailsList.length }}人</span>
        <!-- <span>共使用人数：{{ detailData.peopleNumber }}人</span> -->
      </p>
      <ul v-for="(item,index) in useDetailsList" :key="index" class="useDetailsList_class">
        <!-- <p>{{ `顾客${index + 1}` }}</p> -->
        <p> <i v-if="index==0&&item.customerName" style="font-size: 18px;color: #D2D2D2;padding-right: 5px;" class="iconfont">&#xea44;</i>{{ item.customerName }}  {{ item.customerPhone }}</p>
        <li v-for="(v,n) in item.list" :key="n">
          <!-- <div class="liLeft">{{ v.time }}</div> -->
          <div class="liMiddle">
            <span v-if="n == 0">
              <i class="iconOne"></i>
            </span>
            <samp v-else></samp>
          </div>
          <div v-if="item.list.length != n+1" class="label"></div>
          <div class="liRight">
            <p>{{ v.time }} <span>{{ v.name }}</span></p>
            <p v-if="v.rooName">房间名称：{{ v.rooName }}</p>
            <p v-if="v.bedName">{{ getRoomType==2?'床位':'台位' }}：{{ v.bedName }}</p>
          </div>
        </li>
        <div v-if="useDetailsList.length == 0" class="noneDetailsData">
          <h4 class="i">!</h4>
          <h6>暂无数据</h6>
        </div>
      </ul>
    </div>
  </el-dialog>
</template>
<script>
// import { getPartPayList } from "./../api/";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Object,
      default: Object
    },
    detailDataArr: {
      type: Array,
      default: Array
    },
    getRoomType: {
      type: String,
      default: String,
    }
  },
  data() {
    return {
      useDetailsList: [
        {
          list: []
        }
      ],
      visible: false, // 用来展示详情弹窗
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.visible = val;
        // const { customInfoList } = this.detailData;
        const customInfoList = this.detailDataArr;
        for (let i = 0; i < customInfoList.length; i++) {
          const a = customInfoList[i].logList;
          const b = a.split(';');
          customInfoList[i].list = [];
          // 将数组转换成对象数组
          const arr = [];
          for (let n = 0; n < b.length; n++) {
            const j = {};
            j.main = b[n];
            arr.push(j);
          }
          arr.forEach((item) => {
            const c = item.main;
            const d = c.split(',');
            // 将数组转换成对象数组
            const k = {};
            for (let m = 0; m < d.length; m++) {
              // eslint-disable-next-line vars-on-top, no-var
              //  var k = {};
              k.time = d[0];
              //  k.name = d[1];
              k.name = d[1];
              k.rooName = d[2];
              k.bedName = d[3];
            }
            // eslint-disable-next-line block-scoped-var
            if (k.time != '') {
              customInfoList[i].list.push(k);
            }
          });
        }
        this.useDetailsList = customInfoList;
        console.log('---', this.useDetailsList);
      }
    }
  }
};

</script>

<style lang="less" scoped>
.useDetails {
    min-height: 300px;
    ul {
        list-style-type: none;
        .noneDetailsData {
            padding: 100px 0 0 0;
            .i {
                display: block;
                text-align: center;
                width: 22px;
                height: 22px;
                line-height: 22px;
                font-size: 17px;
                color: #cecece;
                border: 2px solid #cecece;
                margin: 0 auto;
                border-radius: 50%;
            }
            h6 {
                color: #999;
                font-size: 14px;
                text-align: center;
                height: 40px;
                line-height: 40px;
            }
        }
        li {
            display: flex;
            line-height: 20px;
            .liLeft {
                padding-top: 3px;
                width: 90px;
                font-size: 14px;
                line-height: 16px;
                color: #333;
            }
            .liMiddle {
                width: 31px;
                padding-top: 5px;
                position: relative;
                z-index: 1;
                span {
                    display: block;
                    width: 17px;
                    height: 17px;
                    border-radius: 50%;
                    background-color: #fff;
                    border: 1px solid #d8dce5;
                    position: relative;
                    margin-left: -1px;
                    margin-top: -3px;
                    .iconOne {
                        display: block;
                        width: 11px;
                        height: 11px;
                        border-radius: 50%;
                        margin: 3px;
                        background-color: #d8dce5;
                    }
                }
                samp {
                    display: block;
                    width: 11px;
                    height: 11px;
                    margin: 0 3px;
                    border-radius: 50%;
                    background-color: #d8dce5;
                }
            }
            .label {
                border-left: 1px solid #d8dce5;
                position: relative;
                top: 6px;
                left: -23px;
                z-index: 0;
            }
            .liRight {
                flex: 1;
                padding-bottom: 30px;
                p {
                    font-size: 14px;
                    color: #333;
                    min-height: 24px;
                    line-height: 24px;
                    span {
                        margin-left: 10px;
                        width: 20px;
                        height: 20px;
                        display: inline-block;
                        background: #D8DCE5FF;
                        color:#fff ;
                        border-radius: 50%;
                        text-align: center;
                        line-height: 20px;
                        font-size: 12px;
                    }
                }
                h5 {
                    font-size: 14px;
                    color: #333;
                    min-height: 24px;
                    line-height: 24px;
                    span {
                        padding-right: 20px;
                    }
                }
            }
        }
    }
}
</style>
<style scoped>
.useDetailsList_class + .useDetailsList_class {
    border-top: 1px solid #e6ebf5;
    padding-top: 19px;
}
.useDetails_title {
    background: rgba(245, 247, 250, 1);
    padding: 16px 21px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}
.useDetailsList_class > p {
    margin-bottom: 20px;
}
</style>
